module.exports = __webpack_public_path__ + "446cf818f768ff4c0597503feffe3c62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/comment-blue.png
// module id = 209
// module chunks = 0